import socialMetricsService from '@/core/services/SocialMetricsService';

interface RefreshDataDetail {
  postId?: string;
  channel?: string;
  uid?: string;
  post_id?: string;
  sac_call_id?: string;
}

/**
 * Creates an event handler for refresh-data events that calls
 * {@link socialMetricsService.forceUpdate} and dispatches the
 * appropriate success or error CustomEvent on the document.
 *
 * @param successEvent - Name of the CustomEvent to dispatch on success.
 * @param errorEvent   - Name of the CustomEvent to dispatch on error.
 */
export function createRefreshDataHandler(
  successEvent: string,
  errorEvent: string,
): (event: Event) => void {
  return (event: Event) => {
    const { postId, channel, uid, post_id, sac_call_id } =
      (event as CustomEvent<RefreshDataDetail>).detail ?? {};

    if (!postId || !channel || !uid) {
      document.dispatchEvent(new CustomEvent(errorEvent));
      return;
    }

    socialMetricsService
      .forceUpdate(channel, postId, uid)
      .then(() => {
        document.dispatchEvent(new CustomEvent(successEvent, { detail: { postId, ...(post_id && { post_id }), ...(sac_call_id && { sac_call_id }) } }));
      })
      .catch(() => {
        document.dispatchEvent(new CustomEvent(errorEvent));
      });
  };
}
